<template></template>

<script>
export default {
  name: 'Index',

  beforeCreate() {
    // Redirect to home page.
    this.$router.replace('/home');
  }
};
</script>



<style theme="light-theater" scoped></style>
